import React from 'react';

import MenuList from '@material-ui/core/MenuList';
import MuiMenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import styled from 'styled-components/macro';

import Animation from '../Animation';
import useTranslations from '../../hooks/useTranslations';
import Colors from '../../internal-components/Colors';
import isPrivilegeEqualsTo from '../../utils/isPrivilegeEqualsTo';

const Slideable = styled.div`
  transition: width 0.5s;
  width: ${({ width }) => width + 'px'};
  height: 100vh;
  background: #fff;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 2;
  padding-bottom: 70px; // due to Zendesk help widget
  box-shadow: inset -20px 2px 8px -25px #000000;
  ${({ customCSS }) => (customCSS ? customCSS : '')}
}
`;

const ResizeBtnWrapper = styled(Animation)`
  position: absolute;
  right: -18px;
  top: 50px;
  z-index: 10;
`;

const ResizeBtn = styled(IconButton)`
  && {
    background: #fff;
    filter: drop-shadow(0 0 2px #e0e0e0);
  }
  &:hover {
    background-color: ${Colors.PRIMARY} !important;
    color: #fff;
  }
`;

const MenuItem = styled(MuiMenuItem)`
  && {
    padding-top: 15px;
    padding-bottom: 15px;
    ${({ otSelected }) => otSelected && 'color: ' + Colors.PRIMARY + ';'}
    ${({ otSelected }) =>
      otSelected && 'background-color: rgba(0, 0, 0, 0.04);'}
    ${({ otSelected }) => otSelected && 'font-weight: 500;'}
  }

  svg {
    ${({ otSelected }) => otSelected && 'color: ' + Colors.PRIMARY + ';'}
  }
`;

const CollapsableMenuView = props => {
  const t = useTranslations();

  return (
    <Slideable
      width={props.menuWidth}
      onMouseOver={() => props.setIsMenuHovered(true)}
      onMouseOut={() => props.setIsMenuHovered(false)}
      customCSS={props.additionalCSS}
    >
      <ResizeBtnWrapper in={props.isMenuHovered && !props.noResizeBtn}>
        <Tooltip
          arrow
          title={
            props.isExpanded
              ? t('form-builder.collapse.button.tooltip')
              : t('form-builder.expand.button.tooltip')
          }
        >
          <ResizeBtn
            size="small"
            onClick={() => props.setIsExpanded(!props.isExpanded)}
          >
            {props.isExpanded ? (
              <KeyboardArrowLeftIcon />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </ResizeBtn>
        </Tooltip>
      </ResizeBtnWrapper>
      {props.topEndPoint}
      <MenuList>
        {props.menuItems.map(
          ({ title, value, icon, privileges, disabled, ...menuItemProps }) => {
            return !privileges ||
              privileges.every(p => isPrivilegeEqualsTo(p)) ? (
              <MenuItem
                {...menuItemProps}
                key={title}
                onClick={() => props.setValue(value)}
                otSelected={value === props.value}
                disabled={disabled}
              >
                {icon && (
                  <Tooltip title={props.isExpanded ? '' : t(title)} arrow>
                    <ListItemIcon>{icon}</ListItemIcon>
                  </Tooltip>
                )}
                {t(title)}
              </MenuItem>
            ) : null;
          }
        )}
      </MenuList>
    </Slideable>
  );
};

export default CollapsableMenuView;
